import { NavLink } from 'react-router-dom';
import { useState } from 'react';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const labels = {
    home: 'Головна',
    employees: 'Наші спеціалісти',
    services: 'Послуги',
    reviews: 'Відгуки',
    news: 'Новини',
    clinic: 'Контакти'
  };

  const navLinkStyle = ({ isActive }: { isActive: boolean }) => ({
    color: 'white',
    textDecoration: 'none',
    fontWeight: isActive ? 600 : 400,
    paddingBottom: '5px',
    borderBottom: isActive ? '2px solid #1abc9c' : '2px solid transparent'
  });

  return (
    <>
      <header style={headerStyle}>
        {/* Лого з картинкою */}
        <div style={logoContainer}>
          <div style={logoWrapper}>
            <img 
              src="/images/unnamed.jpg" 
              alt="Logo" 
              style={logoImage} 
            />
          </div>
          <span style={brandName}>Правобережна психіатрична амбулаторія № 1</span>
        </div>

        {/* Desktop меню */}
        <nav className="desktop-nav">
          {Object.entries(labels).map(([key, label]) => (
            <NavLink
              key={key}
              to={key === 'home' ? '/' : `/${key}`}
              style={navLinkStyle}
            >
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Actions */}
        <div style={actions}>
          <button className="burger" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </header>

      {/* Mobile меню */}
      {menuOpen && (
        <div style={mobileMenu}>
          {Object.entries(labels).map(([key, label]) => (
            <NavLink
              key={key}
              to={key === 'home' ? '/' : `/${key}`}
              style={mobileLink}
              onClick={() => setMenuOpen(false)}
            >
              {label}
            </NavLink>
          ))}
        </div>
      )}

      <style>{`
        .desktop-nav {
          display: flex;
          gap: 30px;
        }

        .burger {
          display: none;
          background: none;
          border: none;
          font-size: 26px;
          color: white;
          cursor: pointer;
          width: 40px;
        }

        @media (max-width: 1024px) {
          .desktop-nav {
            display: none;
          }
          .burger {
            display: block;
          }
          /* Трохи зменшуємо шрифт назви на мобільних, щоб влізло поруч з фото */
          span {
            font-size: 14px !important;
          }
        }
      `}</style>
    </>
  );
}

/* -------- Оновлені стилі -------- */

const headerStyle: React.CSSProperties = {
  height: '80px',
  padding: '0 20px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: 'rgba(30,45,42,0.95)',
  color: 'white',
  position: 'sticky',
  top: 0,
  zIndex: 1000,
};

const logoContainer: React.CSSProperties = {
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
  flexShrink: 1, // дозволяє контейнеру трохи стискатися
};

const logoWrapper: React.CSSProperties = {
  width: '50px',   // Фіксований розмір для стабільності
  height: '50px',
  borderRadius: '8px',
  overflow: 'hidden', // Щоб картинка не виходила за межі радіуса
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0, // Забороняє картинці стискатися
};

const logoImage: React.CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover', // Картинка заповнює весь квадрат без деформації
  display: 'block',
};

const brandName: React.CSSProperties = {
  fontWeight: 600,
  fontSize: 18,
  lineHeight: '1.2',
  maxWidth: '250px', // Обмежуємо ширину тексту, щоб не "штовхав" меню
};

const actions: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
};

const mobileMenu: React.CSSProperties = {
  position: 'fixed',
  top: 80,
  left: 0,
  right: 0,
  bottom: 0, // На весь екран для зручності
  background: 'rgba(30,45,42,0.98)',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  padding: 30,
  zIndex: 999,
};

const mobileLink: React.CSSProperties = {
  color: 'white',
  fontSize: 20,
  textDecoration: 'none',
  borderBottom: '1px solid rgba(255,255,255,0.1)',
  paddingBottom: 15,
};